<template>
  <div>
    <v-dialog
      v-model="isVisible"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      max-width="600"
      persistent
      scrollable
    >
      <v-card v-if="selectedOrder">
        <v-toolbar
          class="red"
          flat
          height="80"
          max-height="80"
        >
          <v-avatar
            color="red darken-3"
          >
            <template v-if="isDeleteMultiple">
              <v-icon
                color="white"
                size="28"
              >
                shopping_cart
              </v-icon>
            </template>

            <template v-else>
              <v-icon
                v-if="selectedOrder.SourceTypeId < 100"
                color="white"
                size="28"
              >
                {{ getOrderSourceTypeById(selectedOrder.SourceTypeId).logo }}
              </v-icon>

              <img
                v-else
                :src="getOrderSourceTypeById(selectedOrder.SourceTypeId).logo"
                style="width: 32px; height: auto;"
              >
            </template>
          </v-avatar>

          <v-toolbar-title class="pl-3 white--text">
            <div class="body-3">
              {{ isDeleteMultiple ? $t('Order.OrderDeleteDialog.DeleteOrders.Title') : $t('Order.OrderDeleteDialog.DeleteOrder.Title') }}
            </div>

            <div class="text-caption red--text text--lighten-4">
              <template v-if="isDeleteMultiple">
                {{ $tc('Order.OrderDeleteDialog.DeleteOrders.Subtitle', selectedOrder.length, {orders: selectedOrder.length}) }}
              </template>
              <template v-else>
                {{ parseInt(selectedOrder.SourceTypeId) >= 100 ? getOrderSourceTypeById(selectedOrder.SourceTypeId).desc : getOrderSourceTypeLangById(selectedOrder.SourceTypeId).Desc }}
                #{{ selectedOrder.OrderCode }}
              </template>
            </div>
          </v-toolbar-title>

          <v-spacer />
        </v-toolbar>

        <v-divider />

        <v-card-text class="pa-3">
          <v-container
            class="pa-1"
            fluid
          >
            <v-row dense>
              <v-col
                class="mb-1"
                cols="12"
              >
                <template v-if="isDeleteMultiple">
                  <span class="text-subtitle-1">
                    {{ $tc('Order.OrderDeleteDialog.DeleteOrders.Body', selectedOrder.length, {orders: selectedOrder.length}) }}
                  </span>
                </template>

                <template v-else>
                  <span class="text-subtitle-1">
                    {{ $t('Order.OrderDeleteDialog.DeleteOrder.Subtitle.Order') }}
                    <strong>#{{ selectedOrder.OrderCode }}</strong> {{ $t('Order.OrderDeleteDialog.DeleteOrder.Subtitle.CancelPermanently') }}
                  </span>
                </template>
              </v-col>
            </v-row>

            <v-row
              v-if="!isDeleteMultiple"
              dense
            >
              <v-col
                cols="12"
                sm="8"
              >
                <v-container
                  class="pa-0"
                  fluid
                >
                  <v-row no-gutters>
                    <v-col
                      cols="4"
                      sm="4"
                    >
                      <span :class="isDarkMode ? 'white--text' : 'black--text'">
                        {{ $t('Order.OrderDeleteDialog.Field.Name').toLocaleUpperCase($i18n.locale) }}
                      </span>
                    </v-col>
                    <v-col
                      class="grey--text text--darken-1"
                      cols="8"
                      sm="8"
                    >
                      {{ (parseInt(selectedOrder.CustomerId) !== 0 || selectedOrder.FullName !== 'null null') ? selectedOrder.FullName : $t('Customer.CustomerType.Visitor') }}
                    </v-col>

                    <v-col
                      cols="4"
                      sm="4"
                    >
                      <span :class="isDarkMode ? 'white--text' : 'black--text'">
                        {{ $t('Order.OrderDeleteDialog.Field.Telephone').toLocaleUpperCase($i18n.locale) }}
                      </span>
                    </v-col>
                    <v-col
                      class="grey--text text--darken-1"
                      cols="8"
                      sm="8"
                    >
                      {{ selectedOrder.Telephone }}
                    </v-col>

                    <v-col
                      cols="4"
                      sm="4"
                    >
                      <span :class="isDarkMode ? 'white--text' : 'black--text'">
                        {{ $t('Order.OrderDeleteDialog.Field.Time').toLocaleUpperCase($i18n.locale) }}
                      </span>
                    </v-col>
                    <v-col
                      class="grey--text text--darken-1"
                      cols="8"
                      sm="8"
                    >
                      {{ selectedOrder.TimeAdded }}
                    </v-col>

                    <v-col
                      cols="4"
                      sm="4"
                    >
                      <span :class="isDarkMode ? 'white--text' : 'black--text'">
                        {{ $t('Order.OrderDeleteDialog.Field.Total').toLocaleUpperCase($i18n.locale) }}
                      </span>
                    </v-col>
                    <v-col
                      class="grey--text text--darken-1"
                      cols="8"
                      sm="8"
                    >
                      <span
                        :class="isDarkMode ? 'white--text' : 'black--text'"
                        class="text-subtitle-1 font-weight-bold"
                      >{{ selectedOrder.Price | currency }}</span>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>

              <v-col
                cols="12"
                sm="4"
              >
                <v-container
                  class="pa-0"
                  fluid
                >
                  <v-row dense>
                    <v-col cols="12">
                      <order-status-chip
                        :order="selectedOrder"
                        dense
                        min-width="190"
                      />
                    </v-col>

                    <v-col cols="12">
                      <order-type-chip
                        :order="selectedOrder"
                        dense
                        label
                        min-width="190"
                      />
                    </v-col>

                    <v-col cols="12">
                      <order-payments-chip
                        :item="selectedOrder"
                        dense
                        min-width="190"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="pa-0">
          <v-container
            class="pa-0"
            fluid
          >
            <v-row no-gutters>
              <v-col
                :class="isDarkMode ? 'red lighten-2' : 'red lighten-4'"
                cols="12"
              >
                <div
                  class="py-2 px-4 text-caption"
                  style="display: table;"
                >
                  <div style="display: table-row">
                    <div
                      class="font-weight-bold pr-2"
                      style="display: table-cell; vertical-align: top;"
                    >
                      {{ $t('Common.Misc.Attention').toLocaleUpperCase($i18n.locale) }}:
                    </div>

                    <div
                      v-if="isDeleteMultiple"
                      style="display: table-cell; vertical-align: middle;"
                    >
                      <div v-safe-html="`&#8226; ${$t('Order.OrderDeleteDialog.Notification.Title')}`" />

                      <div
                        v-safe-html="`&#8226; ${isDeleteAndCopyOrder ? $t('Order.OrderDeleteDialog.Notification.RefundMultipleYes') : $t('Order.OrderDeleteDialog.Notification.RefundMultipleNo')}`"
                        class="mt-1"
                      />

                      <div
                        v-if="appHasFiscalDocsProvider"
                        v-safe-html="`&#8226; ${isDeleteAndCopyOrder ? $t('Order.OrderDeleteDialog.Notification.ReceiptOrInvoiceMultipleCancel') : $t('Order.OrderDeleteDialog.Notification.ReceiptOrInvoiceMultipleKeep')}`"
                        class="mt-1"
                      />

                      <div
                        v-if="!isDeleteAndCopyOrder"
                        v-safe-html="`&nbsp;&nbsp;${$t('Order.OrderDeleteDialog.Notification.Tip')}`"
                        class="mt-1 font-italic font-weight-medium"
                      />
                    </div>

                    <div
                      v-else
                      style="display: table-cell; vertical-align: middle;"
                    >
                      <div v-safe-html="`&#8226; ${$t('Order.OrderDeleteDialog.Notification.Title')}`" />

                      <div
                        v-if="selectedOrderIsRefundable"
                        v-safe-html="`&#8226; ${$t('Order.OrderDeleteDialog.Notification.Amount')} ${$options.filters.currency(selectedOrderRefundableAmount) } ${isDeleteAndCopyOrder ? $t('Order.OrderDeleteDialog.Notification.RefundYes') : $t('Order.OrderDeleteDialog.Notification.RefundNo')}`"
                        class="mt-1"
                      />

                      <div
                        v-if="selectedOrderHasFiscalDocument && orderLatestFiscalDocument(selectedOrder)"
                        v-safe-html="`&#8226; ${FiscalDocTypeEnum.isReceipt(orderLatestFiscalDocument(selectedOrder)?.ReceiptType) ? isDeleteAndCopyOrder ? $t('Order.OrderDeleteDialog.Notification.ReceiptCancel') : $t('Order.OrderDeleteDialog.Notification.ReceiptKeep') : isDeleteAndCopyOrder ? $t('Order.OrderDeleteDialog.Notification.InvoiceCancel') : $t('Order.OrderDeleteDialog.Notification.InvoiceKeep')}`"
                        class="mt-1"
                      />

                      <div
                        v-if="!isDeleteAndCopyOrder && (selectedOrderIsRefundable || selectedOrderHasFiscalDocument)"
                        v-safe-html="`&nbsp;&nbsp;${$t('Order.OrderDeleteDialog.Notification.Tip')}`"
                        class="mt-1 font-italic font-weight-medium"
                      />
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer />

          <v-btn
            class="green--text text--darken-1"
            outlined
            text
            @click.native="isVisible = false"
          >
            {{ $t('Common.Button.No').toLocaleUpperCase($i18n.locale) }}
          </v-btn>

          <v-btn
            class="red darken-1 white--text"
            text
            @click.exact="deleteOrder()"
            @click.native="isVisible = false"
          >
            {{ $t('Common.Button.Yes').toLocaleUpperCase($i18n.locale) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Auth from '@/mixins/auth'
import AppData from '@/mixins/appdata'
import OrderType from '@/mixins/orders/orderType'
import SourceType from '@/mixins/orders/sourceType'
import OrderStatusColor from '@/mixins/orders/orderStatus'
import OrderTypeTime from '@/mixins/orders/orderTypeTime'
import OrderTypeChip from '@/components/orders/common/OrderTypeChip'
import OrderStatusChip from '@/components/orders/common/OrderStatusChip'
import OrderPaymentsChip from '@/components/orders/common/OrderPaymentsChip'
import OrderReceipts from '@/mixins/orders/orderReceipts'
import OrderTransactions from '@/mixins/orders/orderTransactions'
import FiscalDocTypeEnum from '@/api/Enums/FiscalDocTypeEnum'
import OrderEditActionEnum from '@/api/Enums/OrderEditActionEnum.js'

export default {
  components: {
    OrderTypeChip,
    OrderStatusChip,
    OrderPaymentsChip
  },
  mixins: [AppData, Auth, OrderStatusColor, OrderType, OrderReceipts, OrderTransactions, SourceType, OrderTypeTime],
  props : {
    visible: {
      type   : Boolean,
      default: false
    },
    isDeleteAndCopyOrder: {
      type   : Boolean,
      default: false
    },
    selectedOrder: {
      type   : [Object, Array],
      default: undefined
    }
  },
  data() {
    return {}
  },
  computed: {
    FiscalDocTypeEnum() {
      return FiscalDocTypeEnum
    },
    selectedOrderIsRefundable() {
      return this.orderIsRefundable(this.selectedOrder)
    },

    selectedOrderRefundableAmount() {
      return this.orderRefundableAmount(this.selectedOrder)
    },

    selectedOrderHasFiscalDocument() {
      return this.orderHasFiscalDocument(this.selectedOrder)
    },

    isDeleteMultiple() {
      return Array.isArray(this.selectedOrder)
    },

    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    deleteOrder() {
      const orderIdsArray = this.isDeleteMultiple ? this.selectedOrder : [this.selectedOrder.Id]
      if (this.$route.name === 'OrdersSaved') {
        window.callAS(window.SocketCommand.Cart.Destroy, {CartId: orderIdsArray})
      } else {
        if (this.isDeleteAndCopyOrder) {
          window.callAS(window.SocketCommand.Order.Edit, {
            order_id  : this.selectedOrder.Id,
            catalog_id: this.selectedOrder?.ExternalCatalogId || null,
            //cancel    : true,
            action    : OrderEditActionEnum.CANCEL,
            Reserved  : parseInt(this.posUser.staff_id)
          })
        } else {
          window.callAS(window.SocketCommand.Order.Delete, {Id: orderIdsArray}, window.SocketCommand.Order.StatusUpdated)
        }
      }

      this.$bus.$emit('order-deleted', this.selectedOrder)
      this.$emit('order-deleted', this.selectedOrder)
    }
  }
}
</script>
